import SignupMethodScreen from "./SignupMethodScreen";

export default function AuthNavigator() {
    return <SignupMethodScreen />;
}
